var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
export class GlobalAdminExternalResearcherOrganizationUserListViewModel {
    constructor(opts) {
        this.organizationsManager = opts.container.organizationsManager;
        this.routingUIManager = opts.container.routingUIManager;
        this.authManager = opts.container.authManager;
        this.organizationId = opts.organizationId;
        this.onNewUser = opts.onNewUser;
        this.onViewUserDetails = opts.onViewUserDetails;
    }
    get users() {
        const organization = this.organizationsManager.getOrganization(this.organizationId);
        if (organization === NOT_LOADED)
            return NOT_LOADED;
        return organization === null || organization === void 0 ? void 0 : organization.users;
    }
    newUser() {
        this.onNewUser();
    }
    viewUserDetails(user) {
        this.onViewUserDetails(user.id);
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminExternalResearcherOrganizationUserListViewModel.prototype, "users", null);
